module.exports = __webpack_public_path__ + "static/img/coronation.613715f1.png";